<template>
    <div
        v-if="reservation"
        id="lx-online-booking-payment-request-confirmation"
        class="lx-online-booking-payment-request-confirmation"
    >
        <b-container>
            <b-row>
                <b-col
                    v-if="reservation.payment_method_confirmation_status === PAYMENT_METHOD_CONFIRMATION_STATUS_PENDING"
                    md="12"
                    style="margin-bottom: 30px"
                >
                    <card class="lx-online-booking-payment-request-confirmation__success-card">
                        <template #header-content>Payment Method Pending Confirmation (Microdeposits)</template>
                        <template #body>
                            <p>
                                Expect a $0.01 deposit to the bank account in 1-2 business days and an email with
                                additional instructions to verify it. Verification attempts have a limit of three
                                failures. If you exceed this limit, we can no longer verify the bank account. In
                                addition, microdeposit verifications have a timeout of 10 days. If you can’t verify
                                microdeposits in time, you will need to process payment again.
                            </p>
                        </template>
                    </card>
                </b-col>
                <b-col v-else md="12" style="margin-bottom: 30px">
                    <card class="lx-online-booking-payment-request-confirmation__success-card">
                        <template #header-content>Your payment has been successfully processed!</template>
                        <template #body><p>Thank you!</p></template>
                    </card>
                </b-col>
                <b-col md="12" style="margin-bottom: 30px">
                    <online-booking-reservation-optional-travel-insurance />
                </b-col>
            </b-row>
        </b-container>
    </div>
    <div v-else />
</template>

<script>
import { mapGetters } from 'vuex';
import Card from '../../generic/card/card.vue';
import OnlineBookingReservationOptionalTravelInsurance from '../reservation/optional-travel-insurance/online-booking-reservation-optional-travel-insurance.vue';
import { PAYMENT_METHOD_CONFIRMATION_STATUS_PENDING } from '../../../constants';

export default {
    name: 'OnlineBookingPaymentRequestConfirmation',
    components: { Card, OnlineBookingReservationOptionalTravelInsurance },
    computed: {
        ...mapGetters('onlineBooking', ['reservation']),
    },
    data() {
        return {
            PAYMENT_METHOD_CONFIRMATION_STATUS_PENDING: PAYMENT_METHOD_CONFIRMATION_STATUS_PENDING,
        };
    },
    mounted() {
        window.scrollTo(0, 0);
    },
};
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/mixins/_breakpoints.scss';

#lx-online-booking-payment-request-confirmation .lx-online-booking-payment-request-confirmation {
    &__success-card {
        p {
            margin-bottom: 0;
        }
    }
}
</style>
